import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { SensorDto } from 'src/app/shared/dto/sensor.dto';
import { SocketService } from 'src/app/shared/services/socket.service';
import { Messages } from 'src/app/shared/sockets/enums/messages';
import { Client, formatClientRoom, RoomNames } from 'src/app/shared/sockets/enums/rooms';

@Injectable({
    providedIn: 'root'
})
export class SensorsService {
    
    public machineSensors$: Observable<SensorDto>;

    private machineSensorsSubject = new BehaviorSubject<SensorDto>(new SensorDto());
    private messageSubscription: Subscription | undefined;

    private readonly socketService = inject(SocketService);

    constructor() {
        this.machineSensors$ = this.machineSensorsSubject.asObservable();
    }

    async setupWebSocket(): Promise<void> {
        this.socketService.conectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.SENSORS_ROOM));
        this.messageSubscription = this.socketService.getNotifications(Messages.SENSOR_DATA_CHANGED).subscribe(async (data) => {
            this.validateSensorData(data);

            let sensorData: SensorDto = data as SensorDto;
            this.machineSensorsSubject.next(sensorData);
        });
    }

    disconnectWebSocket(): void {
        if(this.messageSubscription){
            this.messageSubscription.unsubscribe();
        }
        this.socketService.disconnectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.SENSORS_ROOM));
    }

    private validateSensorData(sensorData: any) {
        if (!sensorData) {
            throw new Error('Los datos del sensor con invalidos.');
        }

        if (!sensorData.id || typeof sensorData.id !== 'number' || sensorData.id < 0) {
            throw new Error('El id del sensor ha de ser valido.');
        }

        if (!sensorData.value && sensorData.value != 0 || typeof sensorData.value !== 'number') {
            throw new Error('El valor del sensor ha de ser valido.');
        }

        if (!sensorData.orderProcessId || typeof sensorData.orderProcessId !== 'number' || sensorData.orderProcessId < 0) {
            throw new Error('El id del proceso en el sensor ha de ser valido.');
        }

        if (!sensorData.machineId || typeof sensorData.machineId !== 'number' || sensorData.machineId < 0) {
            throw new Error('El id de la maquina en el sensor ha de ser valido.');
        }
    }
}
